module.exports = __webpack_public_path__ + "static/media/co-hover-min.e2fc95fd.png";